import React from 'react';
import { useGame } from '../context/GameContext.jsx';

const ToastMessage = () => {
  const { toastMessage, showToast, hideToastMessage } = useGame(); // Importa hideToastMessage

  if (!toastMessage && !showToast) {
    return null;
  }

  return (
    <div
      className={`toast-message-container ${showToast ? 'fade-in' : ''}`}
      onClick={hideToastMessage} // Adiciona onClick para fechar o toast
    >
      {toastMessage}
    </div>
  );
};

export default ToastMessage;
